interface BrandingImages {
	logoLight: string
	logoDark: string
	logoMark: string
	favicon: string
}

interface CustomerLogo {
	src: string
	alt: string
}

interface BrandingConfig {
	companyName: string
	productName: string
	marketingHeadline: string
	description: string
	customerLogosHeadline: string
	customerLogos: readonly CustomerLogo[]
	images: BrandingImages
	supportEmail: string
	documentationUrl: string
	releaseNotesUrl: string
	termsUrl: string
	privacyUrl: string
	salesCalLink: string
	customDomainExample: string
	copyrightText: string
}

export const branding = {
	companyName: 'Bytebeam',
	productName: 'Bytebeam Platform',
	marketingHeadline: 'Powering the Future of IoT Devices',
	description:
		'Bytebeam is an all in one cloud backend platform for IoT, helping you manage your devices at any scale with ease and confidence.',
	customerLogosHeadline: 'Trusted by leading clients worldwide',
	customerLogos: [
		{ src: '/branding/clients/baaz-bikes.svg', alt: 'Baaz Bikes' },
		{ src: '/branding/clients/bosch.svg', alt: 'Bosch' },
		{ src: '/branding/clients/bullwork-mobility.svg', alt: 'Bullwork Mobility' },
		{ src: '/branding/clients/ecozen.svg', alt: 'Ecozen' },
		{ src: '/branding/clients/evage.svg', alt: 'Evage' },
		{ src: '/branding/clients/exide.svg', alt: 'Exide' },
		{ src: '/branding/clients/exponent.svg', alt: 'Exponent' },
		{ src: '/branding/clients/inverted.svg', alt: 'Inverted' },
		{ src: '/branding/clients/kptl.svg', alt: 'KPTL' },
		{ src: '/branding/clients/lectrix.svg', alt: 'Lectrix' },
		{ src: '/branding/clients/lohum.svg', alt: 'Lohum' },
		{ src: '/branding/clients/matter.svg', alt: 'Matter' },
		{ src: '/branding/clients/my-tvs.svg', alt: 'myTVS' },
		{ src: '/branding/clients/naarni.svg', alt: 'NaArNi' },
		{ src: '/branding/clients/numeros.svg', alt: 'Numeros' },
		{ src: '/branding/clients/resync.svg', alt: 'Resync' },
		{ src: '/branding/clients/river.svg', alt: 'River' },
		{ src: '/branding/clients/royal-enfield.svg', alt: 'Royal Enfield' },
		{ src: '/branding/clients/simple-energy.svg', alt: 'Simple Energy' },
		{ src: '/branding/clients/the-energy-company.svg', alt: 'The Energy Company' },
		{ src: '/branding/clients/tork.svg', alt: 'Tork' },
		{ src: '/branding/clients/upliance.svg', alt: 'Upliance' },
		{ src: '/branding/clients/zypp-electric.svg', alt: 'Zypp Electric' },
	],
	images: {
		logoLight: '/branding/logo-light.svg',
		logoDark: '/branding/logo-dark.svg',
		logoMark: '/branding/logo-mark.png',
		favicon: '/branding/favicon.ico',
	},
	supportEmail: 'support@bytebeam.io',
	documentationUrl: 'https://www.bytebeam.io/docs',
	releaseNotesUrl: 'https://www.bytebeam.io/docs/release-notes',
	termsUrl: 'https://www.bytebeam.io/terms-of-service',
	privacyUrl: 'https://www.bytebeam.io/privacy-policy',
	salesCalLink: 'kraviteja/bytebeam-101',
	customDomainExample: 'client-name.bytebeam.io',
	copyrightText: 'Copyright © {year} IoTExpress Technologies Pvt. Ltd. All rights reserved.',
} satisfies BrandingConfig
